export const BILLING_EMAIL = 'billing@cfamockexam.com';
export const SUPPORT_EMAIL = 'support@cfamockexam.com';
/** Primary outbound / marketing From (Mailcow SMTP). */
export const HELLO_EMAIL = 'hello@cfamockexam.com';
